import { theme } from 'configs/styled';
import Title from 'containers/DriverPortalPage/components/Title';
import React from 'react';

interface IRequiredTitle {
  message: string;
  fontSize?: string;
  style?: React.CSSProperties;
}

const RequiredTitle: React.FC<IRequiredTitle> = props => {
  const { message, fontSize = theme.fontSize.xl, style } = props;
  return (
    <>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <div>
          <Title
            fontSize={fontSize}
            color={theme.palettes.red}
            style={{ margin: '0' }}
          >
            *&nbsp;
          </Title>
        </div>
        <div>
          <Title style={style} fontSize={fontSize}>
            {message}
          </Title>
        </div>
      </div>
    </>
  );
};

export default RequiredTitle;
